module.exports = __webpack_public_path__ + "img/checkout.e275bf6b.gif";